export const BASE_ENDPOINT = process.env.REACT_APP_BASE_ENDPOINT
export const GET_AIRPORTS = `${BASE_ENDPOINT}/api/v1/ver/queryAirports`
export const GET_AIRCRAFTS = `${BASE_ENDPOINT}/api/v1/ver/aircraftList`
export const GET_AIRLINES = `${BASE_ENDPOINT}/api/v1/ver/airlineList`
export const GET_FLIGHTS_BY_DATE_AND_AIRLINE = `${BASE_ENDPOINT}/api/v1/ver/queryFlights`
export const GET_HOTEL_NAMES = `${BASE_ENDPOINT}/api/v1/hotel/queryHotelNames`
export const GET_CITIES = `${BASE_ENDPOINT}/api/v1/hotel/queryCityNames`
export const GET_COUNTRIES = `${BASE_ENDPOINT}/api/v1/hotel/queryCountryNames`
export const GET_CUSTOMERS = `${BASE_ENDPOINT}/api/v1/customer`
export const GET_COMPANIES = `${BASE_ENDPOINT}/api/v1/customer/company`
export const GET_COORDINATES_FROM_ADDRESS = `${BASE_ENDPOINT}/api/v1/car/getCoordinatesFromAddress`